import React from 'react';
import { useRecoilState } from 'recoil';
import { Divider, Grid } from '@material-ui/core';
import { styled } from '@mui/material/styles';
import { mainBlueColor } from '../../GlobalState';

type TProps = {
  title: string | React.ReactNode;
  height: number;
  children: React.ReactNode;
  marginBottom?: number;
};

export const TableTitle: React.FC<TProps> = ({
  title,
  height,
  children,
  marginBottom
}) => {
  const [mainColor] = useRecoilState(mainBlueColor);

  return (
    <>
      <SubContainer marginBottom={marginBottom}>
        <TextMainContainer mainColor={mainColor} height={height}>
          <TextContainer>{title}</TextContainer>
        </TextMainContainer>
        <InputMainContainer height={height}>{children}</InputMainContainer>
      </SubContainer>
      <Divider style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }} />
    </>
  );
};

const SubContainer = styled('div')(
  ({ marginBottom }: { marginBottom?: number }) => ({
    marginLeft: 15,
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    marginBottom: marginBottom || 0
  })
);

const TextContainer = styled('div')({
  marginLeft: 15,
  color: '#FFFFFF',
  fontSize: 14
});

const InputMainContainer = styled('div')(({ height }: { height: number }) => ({
  display: 'flex',
  backgroundColor: '#F5F5F5',
  height: height,
  alignItems: 'center',
  width: '100%'
}));

const TextMainContainer = styled('div')(
  ({ mainColor, height }: { mainColor: string; height: number }) => ({
    display: 'flex',
    backgroundColor: mainColor,
    width: '50%',
    height: height,
    alignItems: 'center'
  })
);
